import {connect} from 'react-redux';

import {type GlobalState} from 'types/store';
import {type Post} from 'mattermost-redux/types/posts';
import {getCurrentRelativeTeamUrl} from 'mattermost-redux/selectors/entities/teams';
import {makeGetDisplayName} from 'mattermost-redux/selectors/entities/users';
import {makeGetFilesForPost} from 'mattermost-redux/selectors/entities/files';

import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';

import {PostQuote} from './post_quote';

type Props = {
    post: Post;
};

function makeMapStateToProps() {
    const getDisplayName = makeGetDisplayName();
    const selectFilesForPost = makeGetFilesForPost();

    return (state: GlobalState, {post}: Props) => {
        const currentTeamUrl = getCurrentRelativeTeamUrl(state);
        const userDisplayName = getDisplayName(state, post.user_id);
        const fileInfos = selectFilesForPost(state, post.file_ids);

        return {
            overrideUsername: getPostOverrideUsername(state, post),
            currentTeamUrl,
            userDisplayName,
            fileInfos,
            post,
        };
    };
}

export default connect(makeMapStateToProps)(PostQuote);
